import { useSkin } from '@/components/SkinContext';
import { SKIN_CONFIGS } from '@/lib/index';

export function SkinPicker() {
  const { activeSkin, setSkin } = useSkin();

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      {SKIN_CONFIGS.map((skin) => {
        const isActive = skin.id === activeSkin.id;
        return (
          <button
            key={skin.id}
            onClick={() => setSkin(skin.id)}
            title={`Versão ${skin.id.replace('s', '')}`}
            style={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              backgroundColor: skin.bg,
              border: isActive ? '2.5px solid white' : '2px solid rgba(255,255,255,0.3)',
              cursor: 'pointer',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              boxShadow: isActive ? '0 0 0 1.5px rgba(0,0,0,0.3)' : 'none',
              outline: 'none',
              transition: 'transform 0.15s ease, box-shadow 0.15s ease',
            }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.18)'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)'; }}
          >
            {/* Inner dot — skin's ink color */}
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor: skin.ink,
                display: 'block',
                flexShrink: 0,
              }}
            />
          </button>
        );
      })}
    </div>
  );
}
